import HasPermission from './HasPermission';

export default function PermissionsGate({
    children,
    pageName = '',
    scopes = []
}: any) {
    const permissionGranted = HasPermission(pageName, scopes);
    if (!permissionGranted) return <></>

    return <>{children}</>;
}